import entityReducer from 'syft-acp-core/reducers/generators/entityReducer'
import * as entityTypes from 'syft-acp-core/reducers/generators/entities'

import * as types from './action-types'
import { FetchShiftIssuesSucceededAction, ShiftIssuesEntity, ShiftIssuesState } from './types'

export default entityReducer<ShiftIssuesEntity>(
  'shiftIssues',
  {
    [entityTypes.ENTITIES_FETCH_BEGIN]: types.SHIFT_ISSUES_FETCH_BEGIN,
    [entityTypes.ENTITIES_FETCH_FAILED]: types.SHIFT_ISSUES_FETCH_FAILED,
    [types.SHIFT_ISSUES_FETCH_SUCCEEDED]: (
      state: ShiftIssuesState,
      action: FetchShiftIssuesSucceededAction,
    ) => {
      const shiftID = action?.request?.shiftID
      const settled = { ...state, isLoadingData: false, isSavingData: false }

      if (!shiftID) {
        return settled
      }

      return {
        ...settled,
        entityMap: {
          ...state.entityMap,
          [shiftID]: { issues: action.payload?.issues ?? [] },
        },
      }
    },
  },
  {
    localEntityMap: true,
    groupBy: ['shiftID'],
  },
)
